import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const SuppliersRoutes: Routes = [
  {
    path: "suppliers",
    loadComponent: () =>
      import("./suppliers/suppliers.component").then(
        (m) => m.SuppliersComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./suppliers-list/suppliers-list.component").then(
            (m) => m.SuppliersListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./supplier-form/supplier-form.component").then(
            (m) => m.SupplierFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./supplier-form/supplier-form.component").then(
            (m) => m.SupplierFormComponent,
          ),
      },
    ],
  },
];
